import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormikProvider, useFormik } from "formik";
import {
  OcCard,
  OcCardButtonBar,
  OcConfirmationDialog,
  OcSettingSwitchFormik,
} from "oc/components";
import { useOcProperty } from "oc/hooks/use-property";
import { useOcFormikHelper } from "oc/utils";

interface MyTimesheetGeneralSettingsProps {
  isMobile: boolean;
}

export const MyTimesheetGeneralSettings = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isMobile,
}: MyTimesheetGeneralSettingsProps) => {
  const { t } = useTranslation();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const { data, loading } = useOcProperty({
    resource: "myTimeSheet",
    key: "saveNewProjectByUserEnabled",
  });

  const formik = useFormik({
    initialValues: { allowNewProject: data === "true" },
    onSubmit: () => {
      updateProperties();
    },
    enableReinitialize: true,
  });

  const { loadingState, updateProperties, error } = useOcFormikHelper({
    defaultResource: "myTimeSheet",
    formik,
    valuesExtraData: {
      allowNewProject: {
        key: "saveNewProjectByUserEnabled",
        loading,
        returnType: "boolean",
        type: "switch",
      },
    },
  });

  const handleSave = () => {
    setShowConfirmDialog(false);
    formik.submitForm();
  };

  const handleCancel = () => {
    formik.resetForm();
  };

  const handleDialogCancel = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <OcConfirmationDialog
        showDialog={showConfirmDialog}
        onClose={handleSave}
        onCancel={handleDialogCancel}
        title={t("OC_CONFIRM_SETTING")}
        texts={[t("OC_CONFIRM_SETTING_INFO")]}
        okButtonText={t("OC_ALL_RIGHT")}
        cancelButtonText={t("OC_CANCEL")}
      />
      <OcCard label={t("OC_SETTINGS")} loading={loading} error={!!error}>
        <FormikProvider value={formik}>
          <OcSettingSwitchFormik
            name="allowNewProject"
            id="saveNewProjectByUserEnabled"
            label={t("MY_TIMESHEET_SAVE_NEW_PROJECT")}
            info={t("MY_TIMESHEET_SAVE_NEW_PROJECT_TEXT")}
            disabled={loadingState}
            isMobile={isMobile}
          />
          <OcCardButtonBar
            handleRightButton={handleCancel}
            rightButtonText={t("OC_CANCEL")}
            rightButtonColor="secondary"
            handlePrimaryButton={() => setShowConfirmDialog(true)}
            primaryButtonText={t("OC_SAVE")}
            primaryButtonDisabled={!formik.dirty || loadingState}
          />
        </FormikProvider>
      </OcCard>
    </>
  );
};

export default MyTimesheetGeneralSettings;
